<template>
  <v-select
    id="axis-select"
    v-model="filter.grupo"
    item-text="nome"
    item-name="grupoId"
    :items="groups.grupos"
    :label="name"
    placeholder="Grupo"
    v-on:change="$emit('onChange')"
    :disabled="disabled"
    :return-object="true"
  >
    <template slot="no-data"> Nenhum Grupo retornado </template>
  </v-select>
</template>

<script>
import { groupAPI } from "../GroupAPI";
import { mapActions } from "vuex";

export default {
  name: "AppGroupSolutionCombobox",
  props: {
    filter: { type: Object },
    disabled: { type: Boolean, default: false },
    name: { type: String, default: "Grupo" },
  },
  mounted() {
    this.loadGroups();
  },
  watch: {
    "filter.grupo": {
      handler(val, oldVal) {
        if (!val) this.loadGroups();
      },
      deep: true,
    },
    filter: {
      handler(newFilter, oldFilter) {
        // Se o filter foi resetado (municipioId mudou ou filter foi limpo)
        if (
          newFilter &&
          oldFilter &&
          newFilter.municipioId !== oldFilter.municipioId
        ) {
          this.loadGroups();
        }
        // Se o grupo foi definido como null, força o clear no componente
        if (newFilter && newFilter.grupo === null) {
          this.$nextTick(() => {
            this.$forceUpdate();
          });
        }
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(["setLoading"]),
    loadGroups() {
      this.setLoading(true);
      groupAPI
        .getWithSolution(this.filter.municipioId)
        .then((resp) => {
          this.groups = resp.data;
          this.groups.grupos = this.groups.grupos.sort(this.compare);

          if (
            this.groups &&
            this.groups.grupos.length == 1 &&
            (!this.filter.grupo ||
              (this.filter.grupo && !this.filter.grupo.length))
          ) {
            this.filter.grupo = this.groups.grupos[0];
            this.$emit("onChange");
          }

          this.setLoading(false);
        })
        .catch(this.setLoading(false));
    },
    compare(a, b) {
      if (
        typeof a[this.field] === "string" &&
        typeof b[this.field] === "string"
      ) {
        if (
          a[this.field].normalize("NFD").replace(/[\u0300-\u036f]/g, "") <
          b[this.field].normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        ) {
          return -1;
        }
        if (
          a[this.field].normalize("NFD").replace(/[\u0300-\u036f]/g, "") >
          b[this.field].normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        ) {
          return 1;
        }
      } else {
        if (a[this.field] < b[this.field]) {
          return -1;
        }
        if (a[this.field] > b[this.field]) {
          return 1;
        }
      }
      return 0;
    },
  },
  data() {
    return {
      groups: [],
      field: "nome",
    };
  },
};
</script>
